<template>
  <div class="payment-processing">

    <div class="payment-processing__content">

      <CreditCardLoader :card="getCardInfo"/>

      <div
        class="payment-processing__icon-loader"
        :class="{
          'payment-processing__icon-loader--active': hasSpinnerIconLoader,
          'payment-processing__icon-loader--visible': isSpinnerIconLoaderVisible
        }"
      >
        <VSpinnerIconLoader :loaderOptions="vSpinnerIconLoaderOptionsMock" />
      </div>
    </div>
  </div>
</template>

<script>
import { CreditCardLoader } from '@/components/payment';
import VSpinnerIconLoader from '@/components/commons/VSpinnerIconLoader';

export default {
  name: 'PaymentProcessing',
  components: {
    CreditCardLoader,
    VSpinnerIconLoader,
  },
  props: [
    'card'
  ],
  data: () => ({
    cardDataMock: {
      cardNumber: '1324 5678 9012 3456',
      expirationDate: '10/30',
      holder: 'FULANO B JUNQUEIRA',
      brand: 'MASTERCARD',
    },
    vSpinnerIconLoaderOptionsMock: {
      mainLoaderMessage: 'Processando pagamento...',
    },
    hasSpinnerIconLoader: false,
    isSpinnerIconLoaderVisible: false,
  }),
  computed: {
    getCardInfo() {
      if (this.card) {
        return this.card;
      }
      return this.cardDataMock;
    },
  },
  mounted() {
    this.startSpinLoaderPresentation();
  },

  methods: {

    startSpinLoaderPresentation() {
      setTimeout(() => {
        this.hasSpinnerIconLoader = true;

        setTimeout(() => {
          this.isSpinnerIconLoaderVisible = true;
        }, 100);
      }, 4500);
    }
  }
};
</script>

<style lang="scss" scoped>
  .payment-processing {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 24px);
    justify-content: center;
    width: 100%;

    &__content {
      height: 510px;
    }

    &__icon-loader {
      display: none;
      opacity: 0;
      position: relative;
      top: -70px;
      transition: opacity 1s ease-in;
      z-index: 0;

      &--active {
        display: block;
      }

      &--visible {
        display: block;
        opacity: 1;
      }
    }
  }
</style>
